import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';

type ByPassContextType = {
    userInfo?: IAuthMeV2OutputDto;
    isImpersonated: boolean;
};

const ByPassContext = createContext<ByPassContextType | undefined>(undefined);

export const ByPassProvider: React.FC<React.PropsWithChildren<Record<string, unknown>>> = ({ children }) => {
    const queryClient = useQueryClient(); // Access the query client
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']); // Retrieve userInfo from the cache

    // This is disabled for now, but can be enabled when the impersonation feature is ready to be used in the app
    const isImpersonated = false;

    return (
        <ByPassContext.Provider
            value={{
                userInfo,
                isImpersonated,
            }}
        >
            {children}
        </ByPassContext.Provider>
    );
};

export const useByPassContext = () => {
    const context = useContext(ByPassContext);
    if (!context) {
        throw new Error('useByPassContext must be used within a ByPassProvider.');
    }
    return context;
};
